// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2295":"2cade30b","3022":"0587b4a0","3401":"ac2c8aca","3932":"accf1055","5286":"f7c830e4","6442":"4a8ca4a2","8450":"dddf05dc","9936":"ac2c8aca"}[chunkId] + ".chunk.css";
};